export function createCookieConsentLanguageUpdater(
  setLanguage: (language: string) => Promise<boolean>,
): (language: string) => Promise<void> {
  let latestRequest = 0;
  let pending = Promise.resolve();

  return (language): Promise<void> => {
    const request = ++latestRequest;
    const update = pending.then(async () => {
      // Skip superseded requests and never overlap the library's DOM updates.
      if (request === latestRequest) {
        await setLanguage(language);
      }
    });
    // Keep the queue usable after a failure; the caller still receives it.
    pending = update.catch(() => undefined);
    return update;
  };
}
